/* This is the EMIS Pre Staff Extra components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 79px; width: 391px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 28px">
            <td
              style="
                width: 200px;
                height: 53px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              មុខងារ
            </td>
            <td
              style="
                width: 100px;
                height: 53px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សូមគូសរង្វង់
            </td>
            <td
              style="
                width: 100px;
                height: 28px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ចំនួនបុគ្គលិក
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្រី
            </td>
          </tr>
          <tr
            v-for="(value, row) in d2.length - lastRow"
            :key="row"
            style="height: 25px"
          >
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ d2[row] }}
            </td>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                v-model="data[row].dt[0]"
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row)"
                class="d-inline"
                style="width: 100px; height: 25px; font-size: 9px"
              >
              </v-select>
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[row].dt[1]" style="width: 50px" />
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[row].dt[2]" style="width: 50px" />
            </td>
          </tr>
          <!-- Total Row at the buttom -->
          <tr style="height: 25px">
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                background-color: lightgrey;
                vertical-align: middle;
              "
            ></td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ totalRow[1] }}
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ totalRow[2] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { d2 } from "@/utils/ascf/preConfig.js";
import { yesNo6 } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "cur_cod", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d2: d2,
      yesNo6: yesNo6,
    };
  },
  methods: {
    onSelect: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
  computed: {
    // need to update the total staff in json data
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    //variable control the last added row of 20-21
    lastRow: function () {
      if (this.cur_cod > 12) return 0;
      else return 1;
    },
  },
};
</script>
<style scoped>
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>